import request from '@/utils/request'
const BASE_URL = '/PuPurchaseProcess'

//类别
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getInfo(id) {
    return request({
      url: BASE_URL + '/GetInfo',
      method: 'get'
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data:  id 
    })
  }
}